// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isRecommendedUserItem = objectOf({
  product_id: string,
  nst: string,
  sample_users: number,
  estimated_users_rate: number,
  estimated_users: number,
});

export const isRecommendedUserItems = objectOf({
  sample_users: number,
  sample_personalized_rate: number,
  sample_most_popular_rate: number,
  estimated_personalized_users: number,
  estimated_most_popular_users: number,
  items: arrayOf(isRecommendedUserItem),
});

export const isEngagementRecommenderAnalytics = objectOf({
  coverage: maybe(number),
  precision: maybe(number),
  most_popular_items: arrayOf(string),
  trending_items: arrayOf(string),
  recommended_user_items: isRecommendedUserItems,
  n_catalog_items: number,
});
